import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/tributario/contribuintecadastro/';

class PessoaService {
    constructor() {
        this.idTipo = null;
        this.idConta = null;
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + (data ? data.token : '')
            };
        });
    }

    findAllByTipoCpfCnpj(cpfCnpj) {
        this.idTipo = LoginService.currentUserValue.configuracao.idContrTipoEconomico;
        this.idTipoEventual = LoginService.currentUserValue.configuracao.idContrTipoEventual;
        this.idConta = LoginService.currentUserValue.usuario.idConta;
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'filter?idCliente=' + this.idCliente + '&idTipoContr=' + this.idTipo + '&idTipoEventual=' + this.idTipoEventual + '&idConta=' + this.idConta + '&cpfCnpj=' + cpfCnpj, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }

    findContatosContribuinte(idPessoa) {
        return axios.get(API_URL + 'contatosContribuinte?idPessoa=' + idPessoa, { headers: this.headers });
    }

    findTipoCadastroContribuinte(documento, inscMunic) {
        this.idCliente = LoginService.currentUserValue.usuario.idCliente;
        return axios.get(API_URL + 'tipoCadastroContribuinte?idCliente=' + this.idCliente + '&documento=' + documento + '&inscMunic=' + inscMunic, { headers: this.headers });
    }

    comboByContribuinteFiltro(idCliente, idContribuinte, filtro) {
        return axios.get(API_URL + 'comboByContribuinteFiltro?idCliente=' + idCliente + '&idContribuinte=' + idContribuinte + '&filtro=' + filtro, { headers: this.headers }).then(response => (this.data = response.data.elements));
    }
}

export default new PessoaService();